export var reduxKey = '@@POPOVERS';
export var actionPrefix = '@@POPOVERS';
//# sourceMappingURL=constants.js.map